import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  logExpandBtn: {
    border: 'none',
    backgroundColor: 'inherit',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  logExpandBtnActive: {
    marginBottom: '100px',
  },
});
